module.exports = __webpack_public_path__ + "img/CRM.3f88e592.png";